import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { FulfillmentOrderProcessingService } from 'common/data';

class FulfillmentOrderProcessingStore extends BaseStore {
	constructor(rootStore) {
		super(new FulfillmentOrderProcessingService(rootStore.app.baasic.apiClient));
	}

	@action
	createFulfillmentShipment = async (id, sourceOfChange, updateAndCreatePrintJob) => {
		const response = await this.service.createFulfillmentShipment(id, sourceOfChange, updateAndCreatePrintJob);
		this.item = response;
		return this.item.data;
	};

	@action
	createFulfillmentShipmentBulk = async (params, sourceOfChange, updateAndCreatePrintJob) => {
		const response = await this.service.createFulfillmentShipmentBulk(params, sourceOfChange, updateAndCreatePrintJob);
		this.item = response;
		return this.item.data;
	};

	@action
	assignCarrierServiceAndWarehouse = async (data, sourceOfChange) => {
		await this.service.assignCarrierServiceAndWarehouse(data, sourceOfChange);
	};

	@action
	assignCarrierServiceAndWarehouseBulk = async (data, sourceOfChange) => {
		const response = await this.service.assignCarrierServiceAndWarehouseBulk(data, sourceOfChange);
		return response.data;
	};

	@action
	markAsShipped = async (resource, sourceOfChange) => {
		await this.service.markAsShipped(resource, sourceOfChange);
	};

	@action
	markAsShippedBulk = async (markAsShippedBulkParams, sourceOfChange) => {
		const response = await this.service.markAsShippedBulk(markAsShippedBulkParams, sourceOfChange);
		return response.data;
	};

	@action
	changeShipping = async (changeShippingParams, sourceOfChange) => {
		await this.service.changeShipping(changeShippingParams, sourceOfChange);
	};

	@action
	changeShippingBulk = async (changeShippingBulkParams, sourceOfChange) => {
		const response = await this.service.changeShippingBulk(changeShippingBulkParams, sourceOfChange);
		return response.data;
	};

	@action
	neverShipped = async (neverShippedParams, sourceOfChange) => {
		const response = await this.service.neverShipped(neverShippedParams, sourceOfChange);
		return response.data;
	};

	@action
	neverShippedBulk = async (neverShippedBulkParams, sourceOfChange) => {
		const response = await this.service.neverShippedBulk(neverShippedBulkParams, sourceOfChange);
		return response.data;
	};

	@action
	abortLabelingMode = async (abortLabelingParams, sourceOfChange) => {
		const response = await this.service.abortLabelingMode(abortLabelingParams, sourceOfChange);
		return response.data;
	};

	@action
	splitFulfillmentOrderLabelingMode = async (splitFulfillmentOrderParams, sourceOfChange) => {
		const response = await this.service.splitFulfillmentOrderLabelingMode(splitFulfillmentOrderParams, sourceOfChange);
		return response.data;
	};

	@action
	splitFulfillmentOrder = async (fulfillmentOrders, sourceOfChange) => {
		const response = await this.service.splitFulfillmentOrder(fulfillmentOrders, sourceOfChange);
		this.response = response.data;
		return response.data;
	};

	@action
	editFulfillmentOrderSplit = async (fulfillmentOrders, sourceOfChange) => {
		const response = await this.service.editFulfillmentOrderSplit(fulfillmentOrders, sourceOfChange);
		this.response = response.data;
		return response.data;
	};

	@action
	updateFulfillmentOrderInfo = async (order, sourceOfChange) => {
		const response = await this.service.updateFulfillmentOrderInfo(order, sourceOfChange);
		this.item = response;
		return this.item.data;
	};
}

export default FulfillmentOrderProcessingStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderProcessingStore.js